import { connect } from 'react-redux';
import TrendingCorridorDestinations from './TrendingCorridorDestinations';
import { fetchTrendingCorridorDestinations } from '../../redux/modules/trendingCorridorDestinations';

const mapStateToProps = ({ content: { trending }, renderOptions: { showTrendingModal }, system: { fullURL }}) => ({
  fullURL,
  showTrendingModal,
  tiles: trending
});

const mapDispatchToProps = {
  fetchTrendingCorridorDestinations
};

export default connect(mapStateToProps, mapDispatchToProps)(TrendingCorridorDestinations);
